import React from 'react';

export default () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="#498CF7" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="16" height="16" rx="8"/>
        <path d="M3.5 6H8.67271C8.67271 6 9.93448 6.12618 9.97654 7.13559V11.0465H4.97206C4.97206 11.0465 3.54206 11.2148 3.5 9.74271V6Z" fill="white"/>
        <path d="M12.5001 6V11.0525L10.2715 9.57447V7.51412L12.5001 6Z" fill="white"/>
    </svg>
);
